module.exports = __webpack_public_path__ + "static/media/poker_lobby.37dd0878.jpg";